export const keys = {
    production: process.env.REACT_APP_STRIPE_KEY_PROD,
    development: process.env.REACT_APP_STRIPE_KEY_DEV,
};
